import { useContext, useMemo } from "react";
import { CalculatorContext, CalculatorFormulaType } from "./calculator-context";

const FEES: {
  [type in CalculatorFormulaType]: {
    [key in "alpian" | "other"]: { interest: number; overcost: number };
  };
} = {
  managed: {
    alpian: {
      interest: 4.0,
      overcost: 0,
    },
    other: {
      interest: 4.0,
      overcost: 0.63,
    },
  },
  guided: {
    alpian: {
      interest: 4.0,
      overcost: 0,
    },
    other: {
      interest: 4.0,
      overcost: 0.26,
    },
  },
};

const compoundInterest = (principal, years, interest) => {
  const value = principal * Math.pow(1 + interest, years);

  return isNaN(value) ? 0 : value;
};

export const useCalculator = () => {
  const ctx = useContext(CalculatorContext);
  const fees = FEES[ctx.formula];

  const data = useMemo(() => {
    return [5, 10, 15, 20, 25].map((year) => {
      const alpianInterest = fees.alpian.interest / 100;
      const alpianOvercost = fees.alpian.overcost / 100;
      const otherInterest = fees.other.interest / 100;
      const otherOvercost = fees.other.overcost / 100;
      const alpianAmt = compoundInterest(
        ctx.value,
        year,
        alpianInterest - alpianOvercost,
      );
      const otherAmt = compoundInterest(
        ctx.value,
        year,
        otherInterest - otherOvercost,
      );

      return { year, alpianAmt, otherAmt, difference: alpianAmt - otherAmt };
    });
  }, [ctx.value, ctx.formula]);

  return { data, fees, ...ctx };
};
